import EllipsisText from './EllipsisText';

export default EllipsisText;
